import { defaultFill } from './utils/constants';
var muiHouseOutlineBase = {
    paths: [
        {
            path: 'M1.8125,14.1714286 L4.53125,14.1714286 L4.53125,8.68571429 L9.96875,8.68571429 L9.96875,14.1714286 L12.6875,14.1714286 L12.6875,5.94285714 L7.25,1.82857143 L1.8125,5.94285714 L1.8125,14.1714286 Z M1.8125,16 C1.3140625,16 0.887369792,15.8209524 0.532421875,15.4628571 C0.177473958,15.1047619 0,14.6742857 0,14.1714286 L0,5.94285714 C0,5.65333333 0.0641927083,5.37904762 0.192578125,5.12 C0.320963542,4.86095238 0.4984375,4.64761905 0.725,4.48 L6.1625,0.365714286 C6.32864583,0.243809524 6.50234375,0.152380952 6.68359375,0.0914285714 C6.86484375,0.0304761905 7.05364583,0 7.25,0 C7.44635417,0 7.63515625,0.0304761905 7.81640625,0.0914285714 C7.99765625,0.152380952 8.17135417,0.243809524 8.3375,0.365714286 L13.775,4.48 C14.0015625,4.64761905 14.1790365,4.86095238 14.3074219,5.12 C14.4358073,5.37904762 14.5,5.65333333 14.5,5.94285714 L14.5,14.1714286 C14.5,14.6742857 14.322526,15.1047619 13.9675781,15.4628571 C13.6126302,15.8209524 13.1859375,16 12.6875,16 L8.15625,16 L8.15625,10.5142857 L6.34375,10.5142857 L6.34375,16 L1.8125,16 Z',
            fill: defaultFill,
        },
    ],
    title: 'house',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [4, 4],
};
var muiHouseOutline = {
    base: muiHouseOutlineBase,
};
export { muiHouseOutline };
//# sourceMappingURL=houseOutline.js.map